import script from "./JobManager.vue?vue&type=script&setup=true&lang=js"
export * from "./JobManager.vue?vue&type=script&setup=true&lang=js"

import "./JobManager.vue?vue&type=style&index=0&id=dd15bca8&scoped=true&lang=css"
script.__scopeId = "data-v-dd15bca8"

export default script